import React from 'react';
import PropTypes from 'prop-types';
import stringReplace from 'react-string-replace';

import Hyperlink from './hyperlink';
import Countdown from './countdown';

class RichText extends React.Component {
    static propTypes = {
        text: PropTypes.string,
    };

    static defaultProps = {
        text: '',
    };

    //prevent regex expression from reruning if text is unchanged
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.text !== this.props.text;
    }

    /**
     * Text formatter replace basic entities with components
     * @param  {[type]} text [description]
     * @return {[type]}      [description]
     */
    formatText = (text = '', visId) => {
        let replacedText = text;

        //match links
        replacedText = stringReplace(replacedText, new RegExp(/\[(.*)\]/g), (match, i, offset) => {
            const [text, destination] = match.split('|');
            return text && destination ? (
                <Hyperlink key={text + i} to={destination}>
                    {text}
                </Hyperlink>
            ) : null;
        });

        //match countdown timer
        replacedText = stringReplace(replacedText, new RegExp(/\{countdown:(.*)\}/g), (match, i, offset) => {
            return <Countdown key={match} endtime={match} />;
        });

        // match h tags
        replacedText = stringReplace(replacedText, new RegExp(/h[1-6]\.(.*)/gm), (match, i, offset) => {
            let tagPos = offset;
            let tag = text.slice(tagPos, tagPos + 3);
            while (!/h[1-6]\./.test(tag) && tagPos + 3 < text.length) {
                tag = text.slice(tagPos, tagPos + 3);
                tagPos += 1;
            }
            const HTag = tag.slice(0, -1);
            return <HTag key={i}>{match}</HTag>;
        });

        // match s tags
        replacedText = stringReplace(replacedText, new RegExp(/s[1-6]\.(.*)/gm), (match, i, offset) => {
            let tagPos = offset;
            let tag = text.slice(tagPos, tagPos + 3);
            while (!/s[1-6]\./.test(tag) && tagPos + 3 < text.length) {
                tag = text.slice(tagPos, tagPos + 3);
                tagPos += 1;
            }
            let className = `subline-${tag[1] * 1}`;
            return (
                <div key={i + offset} className={className}>
                    {match}
                </div>
            );
        });

        //match bullet points
        replacedText = stringReplace(replacedText, new RegExp(/\*\*(.*)/gm), (match, i, offset) => {
            return visId ? (
                <div className="bullets" key={i + offset} style={{ textAlign: 'left' }}>
                    <span className="bullet-point">●</span>
                    {match}
                </div>
            ) : (
                <div key={i + offset} style={{ textAlign: 'left' }}>
                    &bull;{match}
                </div>
            );
        });

        return replacedText;
    };

    render() {
        const { text, visId } = this.props;
        return <React.Fragment>{this.formatText(text, visId)}</React.Fragment>;
    }
}

export default RichText;
